import React, { Dispatch, SetStateAction } from "react";

import { useState, createContext } from "react";

type PropsType = {
  children: React.ReactNode;
};

type AppDataType = {
  last_eye_test: null | string;
  params: any; // stores all params given when the flow starts
  patientEnrolmentFormData: any; // stores data from the enrolment form
};

export type ActivationsContextType = [
  AppDataType,
  Dispatch<SetStateAction<AppDataType>>,
];

export const ActivationsContext = createContext<ActivationsContextType>([
  { last_eye_test: null, params: null, patientEnrolmentFormData: null },
  () => {},
]);

export const ActivationsProvider = ({ children }: PropsType) => {
  const [appData, setAppData] = useState<AppDataType>({
    last_eye_test: null,
    params: {
      campaignmember_id: null,
    },
    patientEnrolmentFormData: null,
  });

  return (
    <ActivationsContext.Provider value={[appData, setAppData]}>
      {children}
    </ActivationsContext.Provider>
  );
};
